import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {ImportUtil} from '../../utils/importUtil.js';

/* global customElements */
class RoutingTool extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
						
		var routingTool = this;
		setTimeout(function(){
			routingTool.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var routingTool = this;

		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'dl-location-lookup',
					itemid: 'locationLookupStart',
					label: 'Start Location',
					style: 'margin-left: 5px;',
					textstyle: 'width: 250px',
					required: true,
					'classes': 'spacer-toolbar-item'
				},
				{
					tag: 'dl-location-lookup',
					itemid: 'locationLookupEnd',
					label: 'End Location',
					style: 'margin-left: 5px;',
					textstyle: 'width: 250px',
					required: true,
					'classes': 'spacer-toolbar-item'
				},
				{
					tag: 'vaadin-button',					
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:road', ' Route')
					], 
					listeners: {
						click: function() {
							actionRoute();
						}
					}
				},
				{									
					tag: 'div',
					style: 'float: right;margin-top: 37px;',
					children:[
						{
							tag: 'vaadin-button',																								
							'class': 'spacer-toolbar-item',
							style: '',
							children:[
								ElementUtil.makeIcon('vaadin:cog', ' Options')
							],
							listeners: {
								click: function() {
									actionRouteOptions();
								}
							}
						},
						{
							tag: 'span',
							innerHTML: '|'
						},
						{
							tag: 'vaadin-button',						
							theme: 'primary',												
							'class': 'spacer-toolbar-item',
							style: '',
							children:[
								ElementUtil.makeIcon('vaadin:upload', ' Bulk Upload')
							],
							listeners: {
								click: function() {
									actionUpload();
								}
							}
						}
					]
				}				
			]
		});		
		
	
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [							
				{						
					path: 'field',
					header: 'Field',
					width: '7em',
					renderer: function(root, column, rowData) {
						if (rowData.item.highlight) {
							root.style = 'background-color: rgb(88 124 137); color: white;';							
						} else {
							root.style.backgroundColor = '';
						}
						root.innerHTML = rowData.item.field;
					}
				},	
				{						
					path: 'value',
					header: 'Value',
					width: '7em'
				}				
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				}
			}
		});	
				
		var footer = ExportUtil.createExportFooter({
			grid: grid,
			itemid: 'routingTool',
			showDetail: false
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		routingTool.append(flexLayout);	
		
		
		var actionRoute = function() {
			var locationStartField = ElementUtil.query(toolbar, 'locationLookupStart');
			var locationStart = locationStartField.getValue();
			
			var locationEndField = ElementUtil.query(toolbar, 'locationLookupEnd');
			var locationEnd = locationEndField.getValue();
			
			if (locationStart === '' || locationEnd === '') {							
				window.DL.MessageUtil.showOkMessage('Start and End location required');			 
			} else {
				var loadMask = grid.showLoading();
				
				RoutingService.getRoutingToolsService().geocode({
					rawLocation: locationStart
				}).then(function(startArray) {
					var start = startArray[0];
					if (!start.latitude || !start.longitude) {											
						locationStartField.markError('Invaild location');
						loadMask.remove();
					} else {										
						RoutingService.getRoutingToolsService().geocode({
							rawLocation: locationEnd
						}).then(function (endArray) {
							var end = endArray[0];							
							if (!end.latitude || !end.longitude) {											
								locationEndField.markError('Invaild location');
								loadMask.remove();
							} else {
								var request = {
									locations: [
										start,
										end
									]
								};
								
								if (routingTool.routeOptions) {
									request.engineOptions = routingTool.routeOptions;
								}
								
								RoutingService.getRoutingToolsService().routingPoint(request).then(function (results) {
									loadMask.remove();

									var keyValue = [];
									results.forEach(function(result) {
										if (result.failedReport) {
											keyValue.push({
												field: 'Failure Message',
												value: result.failureMessage
											});
										} else {
											var totalRecord = {
												total: 0,
												toll: 0,
												tollAmount: 0,
												ferry: 0
											};
											result.details.forEach(function(detail){
												keyValue.push({
													field: 'State',
													value: detail.state,
													highlight: true
												});
												keyValue.push({
													field: 'Country',
													value: detail.country
												});
												keyValue.push({
													field: 'Total Miles',
													value: Math.round(detail.total * 10) / 10
												});
												keyValue.push({
													field: 'Toll Miles',
													value: Math.round(detail.toll * 10) / 10
												});
												keyValue.push({
													field: 'Toll Amount',
													value: StringUtil.currencyFormat(detail.tollAmount)
												});
												keyValue.push({
													field: 'Ferry Miles',
													value: Math.round(detail.ferry * 10) / 10
												});

												totalRecord.total += detail.total;
												totalRecord.toll += detail.toll;
												totalRecord.tollAmount += detail.tollAmount;
												totalRecord.ferry += detail.ferry;
												});

											keyValue.push({
												field: 'Total',
												value: '',
												highlight: true
											});											
											keyValue.push({
												field: 'Total Miles',
												value: Math.round(totalRecord.total * 10) / 10
											});
											keyValue.push({
												field: 'Toll Miles',
												value: Math.round(totalRecord.toll * 10) / 10
											});
											keyValue.push({
												field: 'Toll Amount',
												value: StringUtil.currencyFormat(totalRecord.tollAmount)
											});
											keyValue.push({
												field: 'Ferry Miles',
												value: Math.round(totalRecord.ferry * 10) / 10
											});
											
										}

									});

									grid.items = keyValue;
								});
							}
						});
					}					
				});
				
			}
		};
		
		var actionUpload = function() {
			
			var uploadWin = ElementUtil.create({			
				tag: 'dl-dialog',
				title: 'Bulk Upload',
				icon: 'vaadin:upload',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						uploadWin.show();
						
						var primaryToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'div',
									innerHTML: 'Format: Text - route per line Route Id (this can anything) TAB Origin TAB Destination'									
								},
								{
									tag: 'vaadin-button',			
									theme: 'primary',
									'class': 'spacer-toolbar-item',
									children:[
										ElementUtil.makeIcon('vaadin:upload', ' Upload')
									], 
									listeners: {
										click: function() {
											actionShowUploadForm();
										}
									}
								},	
								{
									tag: 'hr'
								}
							]

						});
						
						var outputGrid = ElementUtil.create({
							tag: 'dl-backgroundoutput-grid',
							category: 'ROUTING',
							slot: 'primary'							
						});
						
						
						var flexLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [								
								outputGrid,
								primaryToolbar
							]
						});
						uploadWin.addToContentElement(flexLayout);
						
						var actionShowUploadForm = function() {
							
							var uploadWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Import Routing File',
								icon: 'vaadin:upload',
								width: 450,
								height: 315,
								listeners: {
									ready: function () {
										uploadWin.show();

										var uploadHandler = function () {

											var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');

											if (!uploadField.files || uploadField.files.length < 1) {
												window.DL.MessageUtil.showOkMessage('A routing import file is required.');
											} else {
												uploadField.uploadFiles();
											}

										};

										var uploadFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-text-field',
													label: 'Note',
													name: 'note',
													maxLength: 255
												},
												{
													tag: 'vaadin-upload',
													itemid: 'uploadField',
													'no-auto': true,
													'max-files': 1,
													required: true,
													target: '/api/service/routing-tools/routing/upload',
													headers: ImportUtil.getUploadHeader(),
													listeners: {
														'upload-request': function (event) {
															var data = uploadFormPanel.getData();
															event.detail.formData.append('note', data.note);															
														},
														'upload-success': function (event) {
															var responseData = JSON.parse(event.detail.xhr.responseText);
															if (responseData.uploadFile) {
																//error 
																window.DL.MessageUtil.showOkMessage(
																		responseData.uploadFile + '<br>' +
																		responseData.uploadFileType ? responseData.uploadFileType : ''
																		);
															} else {
																window.DL.MessageUtil.showToast('Success', 'File will be processed in the background.', {									
																	theme: 'success'
																});															
																outputGrid.refresh();
																uploadWin.close();
															}
														}
													}
												},
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:upload', ' Upload')
																	],
																	listeners: {
																		click: function () {
																			if (uploadFormPanel.isValid()) {
																				uploadHandler();
																			}
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function () {
																			uploadWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]
										});
										uploadWin.addToContentElement(uploadFormPanel);

									}
								}


							});		
							
						};
						
					}
				}
			});
			
			
		};

		var actionRouteOptions = function() {
			var optionWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Options',
				icon: 'vaadin:cog',
				width: .75,
				height: .75,
				listeners: {
					ready: function () {
						optionWin.show();
						
						var optionPanel = ElementUtil.create({
							tag: 'dl-routing-options-form',
							slot: 'primary',
							listeners: {
								ready: function() {
									Service.getCompanyService().getCurrentCompany().then(function(companyFull){
										RoutingService.getGeospatialOptionsService().getOptions(companyFull.company.companyId).then(function(options){
											optionPanel.loadOptions(options);				
										});
									});
								}
							}
						});
						
						var buttonBar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'footer',
							theme: 'spacing',
							style: 'text-align: center; ',
							children: [								
								{
									tag: 'vaadin-button',
									itemid: 'refresh',
									'class': 'spacer-toolbar-item',
									children:[
										ElementUtil.makeIcon('vaadin:check', ' Apply')
									], 
									listeners: {
										click: function() {											
											routingTool.routeOptions = optionPanel.getOptions();											
											optionWin.close();
										}
									}									
								}
							]
						});
						
						var layout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [								
								optionPanel,
								buttonBar
							]
						});	
						
						optionWin.addToContentElement(layout);
						
					}
				}
			});
			
		};		
		
	}
	
}
customElements.define('dl-routing-tool', RoutingTool);
